import FeedContainer from './FeedContainer';

export default FeedContainer;
